import React, { useState } from 'react';
import { healScheduleLinks } from '../../../api/adminApi';

const SCOPES = {
  missing_exam: 'exam',
  missing_live: 'vc',
  empty: 'all',
};

/**
 * Compact repair control for one flagged session on a day.
 * Runs the schedule link healers for that date across all batches.
 */
const SessionHealButton = ({ isoDate, flag, onHealed }) => {
  const [busy, setBusy] = useState(false);
  const [preview, setPreview] = useState(null);
  const [applied, setApplied] = useState(false);
  const [error, setError] = useState(null);

  const scope = SCOPES[flag] || 'all';

  const changeCount = (result) => {
    if (!result) return 0;
    return (result.healed ?? 0)
      + (result.healedByAttempts ?? 0)
      + (result.healedByWindow ?? 0)
      + (result.repointed ?? 0)
      + (result.created ?? 0)
      + (result.linked ?? 0)
      + (result.added ?? 0);
  };

  const totalChanges = preview
    ? Object.values(preview.results || {}).reduce((sum, result) => sum + changeCount(result), 0)
    : 0;

  const run = async (dryRun) => {
    setBusy(true);
    setError(null);
    try {
      const result = await healScheduleLinks({
        from: isoDate,
        to: isoDate,
        scope,
        dryRun,
      });
      setPreview(result);
      if (!dryRun) {
        setApplied(true);
        if (onHealed) onHealed(result);
      }
    } catch (healError) {
      setError(healError?.response?.data?.message || 'Repair failed.');
    } finally {
      setBusy(false);
    }
  };

  if (applied) {
    return <span className="cal-session-heal-done">Repaired</span>;
  }

  return (
    <div className="cal-session-heal">
      <button type="button" className="sb-btn sb-btn-sm" disabled={busy} onClick={() => run(true)}>
        {busy && !preview ? 'Checking…' : 'Repair links'}
      </button>
      {preview && totalChanges > 0 && (
        <button
          type="button"
          className="sb-btn sb-btn-sm sb-btn-primary"
          disabled={busy}
          onClick={() => run(false)}
        >
          Apply {totalChanges}
        </button>
      )}
      {preview && totalChanges === 0 && (
        <span className="cal-session-heal-none">Nothing to auto-repair</span>
      )}
      {error && <div className="cal-error">{error}</div>}
    </div>
  );
};

export default SessionHealButton;
